import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const workoutsApi = createApi({
  reducerPath: 'workoutsQueries',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Workouts', 'Workout'],
  endpoints: (builder) => ({
    getWorkoutConfigurations: builder.query({
      query: () => ({
        url: `workouts/configuration`,
        method: 'GET',
      }),
    }),
    getWorkouts: builder.query({
      query: ({ page, limit, filters }) => ({
        url: `workouts`,
        method: 'GET',
        params: {
          page,
          limit,
          filters: JSON.stringify(filters),
        },
      }),
      providesTags: ['Workouts'],
    }),
    getWorkoutById: builder.query({
      query: (id) => ({
        url: `workouts/${id}`,
        method: 'GET',
      }),
      providesTags: ['Workout'],
    }),
    createWorkout: builder.mutation({
      query: (newWorkout) => ({
        url: `workouts`,
        method: 'POST',
        body: newWorkout,
      }),
      invalidatesTags: ['Workouts'],
    }),
    updateWorkout: builder.mutation({
      query: ({ id, patchedWorkout }) => ({
        url: `workouts/${id}`,
        method: 'PATCH',
        body: patchedWorkout,
      }),
      invalidatesTags: ['Workouts', 'Workout'],
    }),
    deleteWorkout: builder.mutation({
      query: (id) => ({
        url: `workouts/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Workouts'],
    }),
  }),
});

export const {
  useGetWorkoutConfigurationsQuery,
  useGetWorkoutsQuery,
  useGetWorkoutByIdQuery,
  useCreateWorkoutMutation,
  useUpdateWorkoutMutation,
  useDeleteWorkoutMutation,
} = workoutsApi;
